module.exports = __webpack_public_path__ + "deliver-me-favicon.4386f86aab4e2c62a9af04d5f6743cfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/logos/deliver-me-favicon.png
// module id = 598
// module chunks = 97